module.exports = __webpack_public_path__ + "static/media/mixed.e93e21a2.svg";